/* eslint-disable jsx-a11y/anchor-is-valid */
import "./Content.css";

const Content = (props) => {
  return (
    <>
      <div className="main-content">
        {props.children}
      </div>
    </>
  );
};

export default Content;
